import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { OrderReceiptResponse } from '@models/order';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function Amount({ receipt }:Props) {
    const { t } = useTranslation('orderReceipt');
    const { order } = receipt;
    const {
        paymentAmount, totalAmount, couponDiscount, vatAmount,
        prepaidCardAmount, giftAmount, discounts, pgAmount,
    } = order;
    const orderDiscounts = discounts
        .filter((it) => it.discountScope === 'ORDER');
    const employeeDiscount = orderDiscounts.find((it) => it.discountType === 'EMPLOYEE');
    return (<Column fullWidth>
        <Column fullWidth spacing={0.5}>
            <Row fullWidth justify='space-between'>
                <Text size='title' fontWeight='bold'>{t('amount.total')}</Text>
                <Text size='title' fontWeight='bold'>{totalAmount.toLocaleString()}</Text>
            </Row>
            {(couponDiscount !== 0) && (
                <Fragment>
                    <Row fullWidth justify='space-between'>
                        <Text fontWeight='bold'>{t('amount.coupon')}</Text>
                        <Text>{couponDiscount.toLocaleString()}</Text>
                    </Row>
                    {orderDiscounts
                        .filter((it) => it.discountType === 'COUPON')
                        .map((it, idx) => (
                            <Row fullWidth justify='space-between' key={`${it.couponName} ${idx}`}>
                                <Text>{it.couponName}</Text>
                                <Text>{it.discountAmount.toLocaleString()}</Text>
                            </Row>
                        ))}
                </Fragment>
            )}
            {giftAmount !== 0 && (
                <Fragment>
                    <Row fullWidth justify='space-between'>
                        <Text fontWeight='bold' size='title'>{t('amount.gift')}</Text>
                        <Text fontWeight='bold' size='title'>{giftAmount.toLocaleString()}</Text>
                    </Row>
                    {orderDiscounts
                        .filter((it) => it.discountType === 'GIFT')
                        .map((it, idx) => (
                            <Row fullWidth justify='space-between' key={`gift ${idx}`}>
                                <Text>{it.couponName}</Text>
                                <Text>{it.discountAmount.toLocaleString()}</Text>
                            </Row>
                        ))}
                </Fragment>
            )}
            {prepaidCardAmount !== 0 && (
                <Row fullWidth justify='space-between'>
                    <Text>{t('amount.prepaidCard')}</Text>
                    <Text>{prepaidCardAmount.toLocaleString()}</Text>
                </Row>
            )}
            {employeeDiscount && (
                <Row fullWidth justify='space-between'>
                    <Text>{t('amount.employee')}</Text>
                    <Text>{employeeDiscount.discountAmount.toLocaleString()}</Text>
                </Row>
            )}
        </Column>
        <ReceiptDivider/>
        <Column spacing={0.5} fullWidth>
            <Row fullWidth justify='space-between'>
                <Text size='headline' fontWeight='bold'>{t('amount.paymentAmount')}</Text>
                <Text size='headline' fontWeight='bold'>
                    {pgAmount.toLocaleString()}
                </Text>
            </Row>
            <Row fullWidth justify='space-between'>
                <Text>{t('amount.vat')}</Text>
                <Text>{Math.trunc(vatAmount).toLocaleString()}</Text>
            </Row>
        </Column>
        <ReceiptDivider/>
    </Column>);
}

export default Amount;
